import gatewayAndPriceListSaga from "./gateway_and_price_list_saga";
import gatewayAndPriceListEmailSaga from "./gateway_and_price_list_email_saga";
import gatewayAndPriceListWhatsappSaga from "./gateway_and_price_list_whatsapp_saga";
import gatewayAndPriceListRCSSaga from "./gateway_and_price_list_rcs_saga";

export default [gatewayAndPriceListSaga, gatewayAndPriceListEmailSaga, gatewayAndPriceListWhatsappSaga, gatewayAndPriceListRCSSaga];
